import React from 'react';
import { cn } from '../lib/utils';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  className,
  href,
  variant = 'primary',
  fullWidth = false,
  ...props
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold uppercase tracking-wide transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl rounded-md py-4 px-8 text-lg md:text-xl leading-none';
  const variants = {
    primary: 'bg-[#22c55e] hover:bg-[#16a34a] text-white border-b-4 border-[#15803d]',
    secondary: 'bg-yellow-400 hover:bg-yellow-500 text-black border-b-4 border-yellow-600'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  if (href) {
    return <a href={href} className={cn(baseStyles, variants[variant], widthClass, className)} data-id="element-73">
        {children}
      </a>;
  }
  return <button className={cn(baseStyles, variants[variant], widthClass, className)} {...props} data-id="element-74">
      {children}
    </button>;
}